import { GET } from '@/server/http';
import URLS from '@/server/urls';

export default async (params = {}, options = { showError: true }) => {
    const [ content, error, status ] = await GET(URLS.admin.adminLoginOptions, params, options);
    if (error) return { error, status };
    return content || {};
};
